<script>
import {HorizontalBar} from 'vue-chartjs'

import countryComparisonData from '../../data-2021/countryComparisonData.json'

export default {
  extends: HorizontalBar,
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      countryRankingData: countryComparisonData,
      options: {
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Score'
            }
          }]
        },
        animation: {
          duration: 0
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
